import { Link, useLocation } from 'react-router-dom';

import Icon from 'components/Icon';
import Modal from 'components/Modal';
import Button2 from 'components/Button2';

import style from './style.module.scss';
import useMobile from 'hooks/useMobile.hook';

const ModalLogin = ({ show, setShow, payload = {} }) => {
  const isMobile = useMobile();
  const location = useLocation();

  const urlParams = new URLSearchParams({
    redirect: location.pathname,
    ...payload,
  }).toString();

  return (
    <Modal classes={style} open={show} onClose={setShow}>
      <div className={style.loginModal}>
        <div className={style.header}>
          <Icon.Egg fontSize={isMobile ? 52 : 96} color="white" />
        </div>
        <div className={style.content}>
          <h2>Please sign in to proceed </h2>
          <p>
            Get access to Lab Groups, and all other details that will make your
            life better
          </p>
          <Button2
            color={'primary'}
            component={Link}
            to={`/sign-in?${urlParams}`}
            size={isMobile ? 'small' : 'large'}
            variant={'contained'}
          >
            Log In
          </Button2>
          <Button2
            variant="text"
            color={'primary'}
            size={isMobile ? 'small' : 'large'}
            onClick={() => {
              setShow(false);
            }}
          >
            Cancel
          </Button2>
        </div>
      </div>
    </Modal>
  );
};

export default ModalLogin;
